import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { OptionItem } from '~src/shared/selectors/DdSearchContent';
import SearchListSelector from '~src/shared/selectors/searchListSelector/SearchListSelector';
import { MSFilterTypes, ObjectivesQueryI, ObjectiveStatus } from '~src/store/okrs/interfaces';

const statusOptionsList: StatusFilterOptI[] = [
  { id: ObjectiveStatus.DRAFT, nameKey: 'x.okr.objectives.status.draft' },
  { id: ObjectiveStatus.PLANNED, nameKey: 'x.okr.objectives.status.planned' },
  { id: ObjectiveStatus.IN_PROGRESS, nameKey: 'x.okr.objectives.status.in_progress' },
  { id: ObjectiveStatus.OVERDUE, nameKey: 'x.okr.objectives.status.overdue' },
  { id: ObjectiveStatus.CLOSED, nameKey: 'x.okr.objectives.status.closed' },
];

interface StatusFilterOptI extends OptionItem {
  id: ObjectiveStatus;
  nameKey: string;
}

type StatusFilterI = Pick<ObjectivesQueryI, MSFilterTypes.Status>;

interface Props {
  initialOpts?: ObjectiveStatus[];
  applyFilter(filterName: MSFilterTypes, ids: StatusFilterI[MSFilterTypes.Status]): void;
}

const StatusSelector: FC<Props> = props => {
  const [t] = useTranslation();
  const [selectorInactive, setSelectorInactive] = useState(!props.initialOpts || !props.initialOpts.length);
  const optionsList = useMemo(() => {
    return statusOptionsList.map(item => ({
      ...item,
      name: t(item.nameKey),
    }));
  }, []);

  const applyChecked = (ids: ObjectiveStatus[]) => {
    props.applyFilter(MSFilterTypes.Status, ids);
    setSelectorInactive(!ids.length);
  };

  const resetSelected = () => {
    props.applyFilter(MSFilterTypes.Status, undefined);
    setSelectorInactive(true);
  };

  return (
    <SearchListSelector
      noSearch
      multiSelect
      initialOpt={props.initialOpts}
      inactive={selectorInactive}
      inactiveKey="x.okr.objectives.status_selector.inactive_label"
      onSelect={applyChecked}
      optionsList={optionsList}
      loadingSearch={false}
      noMoreItems
      nothingFoundKey=""
      resetSelected={resetSelected}
    />
  );
};

export default StatusSelector;
